
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.75 4.5a.75.75 0 00-.75.75V6h3v-.75a.75.75 0 00-.75-.75h-1.5zM14.5 6v-.75A2.25 2.25 0 0012.25 3h-1.5A2.25 2.25 0 008.5 5.25V6H4.75a.75.75 0 000 1.5h.078l1.278 11.498A2.25 2.25 0 008.342 21h6.315c1.147 0 2.11-.862 2.236-2.002L18.17 7.5h.079a.75.75 0 000-1.5H14.5zm2.162 1.5H6.337l1.26 11.332a.75.75 0 00.745.668h6.315a.75.75 0 00.745-.668L16.662 7.5zM9.998 9.75a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75zm3 0a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    